<template>
  <div>
    <div class="mb-1 d-flex flex-row">
      <div style="flex:1;" class="pr-2">
        <h6 style="color: #101010;">
          {{ $l('form_header_factory') || '验厂要求' }}
        </h6>
      </div>
    </div>

    <el-form
      ref="baseForm"
      :model="formData"
      :rules="rules"
      size="mini"
      label-position="top"
      :disabled="enableEdit || disabled"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_isFactoryInspection') || '是否需要验厂'"
          >
            <el-select
              v-model="formData.isFactoryInspection"
              :placeholder="
                $l('form_placeholder_isFactoryInspection') ||
                  '请选择是否需要验厂'
              "
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                value="Y"
                :label="$l('form_label_isFactoryInspection_Y') || '需要验厂'"
              />
              <el-option
                value="N"
                :label="$l('form_label_isFactoryInspection_N') || '不需要验厂'"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_factoryInspectionMethods') || '验厂方式'"
          >
            <dict-select
              v-model="formData.factoryInspectionMethods"
              :placeholder="
                $l('form_placeholder_factoryInspectionMethods') ||
                  '请选择验厂方式'
              "
              url="/digitalCenter/common/dict/system"
              :body="{ dictType: 'factoryInspectionMethods' }"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="!disabled">
          <el-form-item>
            <template #label>
              <div>
                <br />
              </div>
            </template>
            <div class="d-flex justify-content-end">
              <el-button
                size="mini"
                type="primary"
                :disabled="enableEdit"
                @click="saveCust()"
              >
                {{ $l('INDEX.btn_save') || '保存' }}
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="pt-2 pb-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <h6 class="m-0">
            {{ $l('form_header_factoryDoc') || '客户验厂资料' }}
          </h6>
          <el-divider direction="vertical" v-if="!docDisabled" />
          <b-button
            v-if="!docDisabled"
            size="sm"
            variant="outline-success"
            @click="addDoc"
            :disabled="enableEdit"
          >
            {{ $l('btn_addDoc') || '新增资料' }}
          </b-button>
        </div>
        <div>
          <vxe-button
            size="mini"
            circle
            @click="getDocData()"
            :disabled="enableEdit"
          >
            <i class="vxe-button--icon vxe-icon--refresh" />
          </vxe-button>
        </div>
      </div>

      <div class="cust-doc-list">
        <el-form
          v-for="(form, index) in listDoc"
          :key="index"
          ref="form"
          :model="form"
          :rules="docRules"
          size="mini"
          :disabled="!form.enableEdit || docDisabled"
        >
          <div class="d-flex">
            <div>
              <div>
                <el-avatar
                  shape="square"
                  :src="form.custFileIcon"
                  :class="{ 'bg-transparent': form.custFileIcon }"
                />
              </div>
              <div
                v-if="
                  !enableEdit && !form.enableEdit && !docDisabled && form.isAllow
                "
                class="text-center mt-2"
              >
                <el-tooltip
                  effect="dark"
                  :content="$l('menu_text_doc_deactivate') || '文档停用'"
                  placement="bottom"
                >
                  <i
                    class="el-icon-delete text-danger tool-btn"
                    @click="deleteDoc(form)"
                  />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  :content="$l('INDEX.btn_tips_edit') || '编辑'"
                  placement="bottom"
                >
                  <i class="el-icon-edit tool-btn" @click="editDoc(form)" />
                </el-tooltip>
              </div>
            </div>
            <div style="flex:1;padding-left: 16px;">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    :label="$l('form_label_custFileName') || '文件名称'"
                    prop="custFileName"
                  >
                    <el-input
                      v-model="form.custFileName"
                      readonly
                      :disabled="!!form.custDocCode"
                      :placeholder="
                        $l('form_placeholder_custFile') || '请选择文件'
                      "
                    >
                      <el-button
                        slot="append"
                        v-if="form.enableEdit && !form.custDocCode"
                        icon="el-icon-folder-opened"
                        @click="uploadDoc(form)"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    :label="
                      $l('form_label_custFileDesc') || '文件类型（可多选）'
                    "
                    prop="custFileDescCodes"
                  >
                    <dict-select
                      v-model="form.custFileDescCodes"
                      url="/master/common/dict/biz"
                      :body="{ dictType: 'custFileDescType' }"
                      :placeholder="
                        $l('form_placeholder_custFileDesc') ||
                          '请选择文件类型（可多选）'
                      "
                      :selectedLabel.sync="form.custFileDesc"
                      selectedLabelSeparator="、"
                      filterable
                      clearable
                      multiple
                      size="mini"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    :label="
                      $l('form_label_changeStatusDesc') ||
                        '文件相关说明（内容会以邮件方式通知相关人员）'
                    "
                    prop="changeStatusDesc"
                  >
                    <el-input
                      v-model="form.changeStatusDesc"
                      :placeholder="
                        $l('form_placeholder_changeStatusDesc') ||
                          '请输入文件相关说明（内容会以邮件方式通知相关人员）'
                      "
                      :readonly="!!form.custDocCode"
                      type="textarea"
                      maxlength="200"
                      :rows="4"
                      show-word-limit
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="form.enableEdit && !docDisabled"
            class="my-2 d-flex justify-content-end"
          >
            <el-button size="small" @click="cancelEdit(index)">
              {{ $l('INDEX.btn_cancel') || '取消' }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="saveDoc(form, index)"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-form>

        <EmptyContent v-if="!listDoc || !listDoc.length" />
      </div>
    </div>

    <DeactivateDoc
      :visible.sync="deactivateDocOpts.visible"
      :custDocCode="deactivateDocOpts.custDocCode"
      @reload="getDocData"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VXETable } from 'vxe-table'
import { request } from '@/api/service'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import EmptyContent from '../empty-content'
import DeactivateDoc from '../cust-folder/components/deactivate-doc'
const initDoc = {
  custFileCode: '',
  custFileUrl: '',
  custFileName: '',
  custFileDescCodes: [],
  custFileDesc: '',
  changeStatusDesc: '',
  enableEdit: true,
}
export default {
  components: { EmptyContent, DeactivateDoc },
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    docDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      listDoc: [],
      currDoc: {},
      rules: {},
      docRules: {
        custFileName: [
          {
            required: true,
            message: this.$l('form_placeholder_custFile') || '请选择文件',
            trigger: 'change',
          },
        ],
        custFileDescCodes: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custFileDesc') ||
              '请选择文件类型（可多选）',
            trigger: 'change',
          },
        ],
        changeStatusDesc: [
          {
            required: true,
            message:
              this.$l('form_placeholder_changeStatusDesc') ||
              '请输入文件相关说明（内容会以邮件方式通知相关人员）',
            trigger: 'blur',
          },
        ],
      },
      fileIcons: null,
      deactivateDocOpts: { visible: false, custDocCode: '' },
    }
  },
  computed: {
    enableEdit() {
      return this.listDoc.some((doc) => !!doc.enableEdit)
    },
  },
  async activated() {
    await this.getFileIcons()
    this.init()
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    async init() {
      this.getCustData()
      this.getDocData()
    },
    async getCustData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async getDocData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerDocFactoryInspectionApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body.data || []

      this.listDoc = data.map((item) => {
        return {
          ...item,
          custFileIcon: this.getFileIcon(item.custFileName),
          enableEdit: false,
        }
      })
    },
    async getFileIcons() {
      if (this.fileIcons) return
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    addDoc() {
      this.listDoc.unshift({ ...initDoc })
      this.currDoc = null
    },
    async deleteDoc({ custDocCode }) {
      this.deactivateDocOpts = { visible: true, custDocCode }
    },
    editDoc(doc) {
      if (this.enableEdit) return
      this.currDoc = JSON.parse(JSON.stringify(doc))
      doc.enableEdit = true
    },
    async saveDoc(doc, index) {
      if (!(await validate.formValidate([this.$refs.form[index]]))) return

      if (this.loadingOpen()) return

      const saveApi = async (doc) => {
        const { custDocCode, custFile, ...data } = doc
        if (custDocCode) {
          return this.$api
            .masterCustomerDocUpdateApi({ ...doc })
            .catch(() => null)
        }

        // 上传文件
        const custFileCode = await this.upload(custFile)
        if (!custFileCode) {
          this.$message.error(this.$l('INDEX.uploader_label_status_error'))
          return
        }

        return this.$api
          .masterCustomerDocFactoryInspectionUploadApi({
            custCode: this.custCode,
            listDoc: [{ ...data, custFileCode }],
          })
          .catch(() => null)
      }

      const res = await saveApi(doc)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getDocData()
    },
    cancelEdit(index) {
      if (!this.currDoc) {
        this.listDoc.splice(index, 1)
      } else {
        this.$set(this.listDoc, index, { ...this.currDoc })
      }
    },
    async uploadDoc(doc) {
      const { file } = await VXETable.readFile().catch(() => ({}))
      if (!file) return

      const { name, size } = file
      doc.custFile = file
      doc.custFileName = name
      doc.custFileSize = this.formatFileSize(size)
      doc.custFileIcon = this.getFileIcon(name)
    },
    formatFileSize(bytes) {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + 'MB'
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + 'KB'
      } else {
        return bytes + 'B'
      }
    },
    upload(file) {
      return new Promise((resolve) => {
        this.push({
          file: file,
          added: ({ md5, suffix }) => {
            return resolve([md5, suffix].filter(Boolean).join('.'))
          },
          fail: () => resolve(),
        })
      })
    },
    async saveCust() {
      const params = {
        custCode: this.custCode,
        isFactoryInspection: this.formData.isFactoryInspection,
        factoryInspectionMethods: this.formData.factoryInspectionMethods,
        isMain: 'Y',
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerSaveFactoryInspectionApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getCustData()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .tool-btn {
    font-size: 20px;
  }
  .el-avatar {
    width: 80px;
    height: 80px;
  }

  .cust-doc-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
